import _ from 'lodash';

export function applyDefaults<T>(defaults: T, overrides: T): T {
  return _.merge({}, defaults, overrides);
}
